import { Component, OnInit, AfterViewInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PrimeNGConfig } from 'primeng/api';

import { LoadingBarModule } from '@ngx-loading-bar/core';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { AngularFireModule } from '@angular/fire/compat';
import { environment } from '../environments/environment';
import { Title } from '@angular/platform-browser';
import { constants } from './shared/constants/constants';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastModule, LoadingBarModule, ConfirmDialogModule, ConfirmPopupModule, AngularFireModule ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: []
})
export class AppComponent implements OnInit, AfterViewInit {
  loaderColor!: string;

  constructor(private primengConfig: PrimeNGConfig, private titleService: Title) { }

  ngOnInit() {
    this.primengConfig.ripple = true;
    this.titleService.setTitle(environment.title);
    const favicon = document.getElementById('appFavicon') as HTMLLinkElement;
    if (favicon) {
      favicon.href = environment.favicon;
    }
    /**
     * MP-5646: the brand's root class on <html>.
     *
     * This was a two-brand switch - add 'pwc' or remove it - so a third brand
     * got NO root class at all and could not hang a brand-scoped rule off one.
     * A brand now declares its own class and anything it declares nothing for
     * falls through to the original behaviour, which is why staftr and pwc are
     * byte-identical: staftr still ends with no class and pwc still ends with
     * 'pwc'.
     *
     * Both known classes are removed first so switching brands in a single
     * page session cannot leave a stale one behind.
     */
    const brand = environment as { brandClass?: string; primaryColor?: string };
    const brandClass = brand.brandClass || (environment.isPWCEnabled ? 'pwc' : '');

    document.documentElement.classList.remove('pwc', 'mplace');
    if (brandClass) {
      document.documentElement.classList.add(brandClass);
    }

    /**
     * Only the FIRST paint uses this: setLoaderColor() overwrites it from the
     * theme's `--loader-color` in ngAfterViewInit. Without a brand value a
     * third brand flashes the Staftr purple before correcting.
     */
    this.loaderColor = brand.primaryColor
      || (environment.isPWCEnabled ? constants.pwcPrimaryColor : constants.staftrPrimaryColor);
    this.storageChangeEventListner();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.setLoaderColor();
    }, 0);
  }

  private setLoaderColor() {
    const computedColor = getComputedStyle(document.documentElement)
      .getPropertyValue('--loader-color')
      .trim();
    
    if (computedColor) {
      this.loaderColor = computedColor;
    }
  }

  storageChangeEventListner(){
    window.addEventListener('storage', (event) => {
      if (event.key === 'isLoggedOut') {
        setTimeout(() => {
          window.location.href = `${environment.clientHost}login`;
        }, 2000);
      }
    })
  }
}
